// ai/* page translations
const ai = {
  aiAnalysis: {
    newChat: 'Cuộc trò chuyện mới',
    send: 'Gửi',
    file: {
      excel: 'Tệp Excel',
      csv: 'Tệp CSV',
      pdf: 'Tệp PDF',
      file: 'Tệp',
      rows: '({n} dòng)',
      download: 'Tải xuống',
      ready: 'Dữ liệu sẵn sàng',
    },
    title: 'Phân tích AI',
    welcome: 'Xin chào! Tôi là trợ lý phân tích AI. Hãy hỏi tôi về dữ liệu thiết bị ép phun, tình trạng sản xuất, phân tích cảnh báo, v.v.',
    welcomeMatch: 'Xin chào! Tôi là trợ lý phân tích AI',
    noResponse: 'Không nhận được phản hồi.',
    errorMessage: 'Xin lỗi, đã xảy ra lỗi khi xử lý tin nhắn của bạn. Vui lòng thử lại sau.',
    assistant: 'Trợ lý AI',
    user: 'Người dùng',
    suggestionsTitle: 'Câu hỏi gợi ý',
    placeholder: 'Nhập câu hỏi... (Shift+Enter để xuống dòng)',
    suggestions: {
      qualityDefectTrend: 'Hiển thị xu hướng tỷ lệ lỗi gần đây dưới dạng biểu đồ đường',
      qualityTopAlarmEquip: 'Thiết bị nào có nhiều cảnh báo chất lượng nhất hôm nay?',
      qualityTempAnalysis: 'Phân tích thay đổi nhiệt độ gần đây của máy ép số 1',
      qualityDefectByEquip: 'Hiển thị số lỗi theo thiết bị trong 7 ngày qua dưới dạng biểu đồ cột',
      productionRunningEquip: 'Tình trạng thiết bị đang vận hành hiện tại?',
      productionTopOutput: 'Thiết bị nào có sản lượng cao nhất hôm nay?',
      productionTrend: 'Hiển thị xu hướng sản lượng 7 ngày qua dưới dạng biểu đồ đường',
      productionUtilizationCompare: 'So sánh tỷ lệ vận hành giữa các thiết bị',
      maintenanceTopAlarm: 'Thiết bị nào có nhiều cảnh báo nhất hôm nay?',
      maintenanceAlarmTrend: 'Hiển thị xu hướng cảnh báo theo thiết bị trong 7 ngày qua',
      maintenanceCycleTimeAnalysis: 'Phân tích thay đổi thời gian chu kỳ gần đây của máy ép số 1',
      maintenanceIdleEquip: 'Tình trạng thiết bị không hoạt động hiện tại?',
      defaultRunningEquip: 'Tình trạng thiết bị đang vận hành hiện tại?',
      defaultTopAlarm: 'Thiết bị nào có nhiều cảnh báo nhất hôm nay?',
      defaultTrend: 'Hiển thị xu hướng sản lượng 7 ngày qua dưới dạng biểu đồ đường',
      defaultShotTempAnalysis: 'Phân tích thay đổi nhiệt độ shot gần đây của máy ép số 1',
    },
  },
  labelReview: {
    stage: {
      collect: 'Thu thập',
      inspect: 'Kiểm tra',
      label: 'Gắn nhãn',
      verify: 'Xác minh',
      drift: 'Trôi',
      retrain: 'Học lại'
    },
    stageNote: {
      collect: 'shot hôm nay',
      inspect: 'quy trình · thị giác · hợp nhất',
      label: 'đã gắn',
      verify: 'đã xác nhận · chờ {n}',
      drift: 'máy ≥1σ / {n}',
      retrain: 'yêu cầu mở · bộ {n}'
    },
    stageHint: {
      collect: 'Shot hôm nay của máy có gắn nhãn',
      inspect: 'Shot có đủ ba kết quả',
      label: 'Shot có nhãn tự động',
      verify: 'Tự động + công nhân xác nhận',
      drift: 'Máy có điểm trung bình giờ gần nhất lệch ≥1σ',
      retrain: 'Yêu cầu học lại đang mở'
    },
    agreeTitle: 'Tỷ lệ khớp nhãn',
    agreeNote: 'mẫu kiểm {n} · mục tiêu {target}% (1.000)',
    agreeHint: 'Công nhân kiểm 2% ngẫu nhiên nhãn tự xác nhận — chỉ tiêu',
    queueTitle: 'Hàng chờ duyệt',
    queueSub: '{n} · mẫu kiểm {a}',
    allEquipment: 'Tất cả máy',
    emptyQueue: 'Không có shot cần duyệt',
    doneN: 'Đã xác nhận: {n}',
    pickOne: 'Chọn một shot trong hàng chờ',
    shotN: 'Shot #{n}',
    trendTitle: '20 shot gần nhất',
    sigmaLine: 'Giới hạn 3σ',
    noTrend: 'Không có dữ liệu',
    decideTitle: 'Công nhân xác nhận',
    autoLabel: 'Nhãn tự động',
    choice: {
      OK: 'Đạt',
      FLASH: 'Bavia',
      WELDLINE: 'Đường hàn',
      SHORT: 'Thiếu liệu',
      SINK: 'Lõm co',
      PROCESS: 'Lỗi (quy trình)',
      SKIP: 'Bỏ qua'
    },
    saved: 'Shot #{shot} → {label}',
    saveFailed: 'Không lưu được. Thử lại',
    keysNote: 'Phím 1–6 · S bỏ qua · ←/→ di chuyển.',
    requestsTitle: 'Yêu cầu học lại',
    noRequests: 'Chưa có yêu cầu',
    cases: '',
    kind: {
      PROCESS: 'AI quy trình',
      VISION: 'AI thị giác',
      FUSION: 'Trọng số hợp nhất',
      ALL: 'Tất cả'
    },
    reason: {
      BATCH: 'bộ 1.000',
      INCREMENTAL: 'bộ +100',
      DRIFT: 'Trôi',
      ACCURACY: 'Khớp thấp',
      FUSION_TUNE: 'nhãn +200'
    },
    reqStatus: {
      REQUESTED: 'Đã yêu cầu',
      TRAINING: 'Đang học',
      DONE: 'Xong',
      REJECTED: 'Từ chối'
    }
  },
  aiManage: {
    addBtn: 'Thêm kết nối mô hình',
    tabs: { connections: 'Kết nối mô hình', calls: 'Lịch sử gọi' },
    provider: { OPENAI_COMPATIBLE: 'Tương thích OpenAI (DGX, LM Studio, ...)', ANTHROPIC: 'Anthropic Claude' },
    feature: {
      CHAT_SQL: 'Phân tích AI · hiểu câu hỏi & tạo SQL (gọi công cụ)',
      CHAT_ANSWER: 'Phân tích AI · soạn câu trả lời',
      ANALYSIS: 'Phân tích AI · tác tử phân tích dữ liệu',
      VISUALIZATION: 'Phân tích AI · tạo biểu đồ',
      REPORT: 'Báo cáo · báo cáo ngày/tuần/tháng, phân tích cảnh báo, đề xuất',
    },
    featureShort: { CHAT_SQL: 'SQL', CHAT_ANSWER: 'Trả lời', ANALYSIS: 'Phân tích', VISUALIZATION: 'Biểu đồ', REPORT: 'Báo cáo' },
    connections: {
      title: 'Kết nối mô hình',
      help: 'Các kết nối LLM mà chatbot và báo cáo sử dụng. Khóa được mã hóa khi lưu và không hiển thị lại. Để trống khóa để dùng biến môi trường máy chủ (OPENAI_API_KEY / ANTHROPIC_API_KEY).',
      empty: 'Chưa có kết nối mô hình nào.',
    },
    card: {
      active: 'Đang dùng', inactive: 'Tạm dừng', keySaved: 'Đã lưu khóa', keyEnv: 'Khóa môi trường', keyNone: 'Không có khóa',
      workspace: 'Workspace', testFailed: 'Kết nối thất bại — xem chi tiết lỗi bên dưới', errorDetail: 'Xem chi tiết lỗi',
      noFeatures: 'Chưa gán chức năng', test: 'Kiểm tra', testing: 'Đang kiểm tra…', edit: 'Sửa', delete: 'Xóa',
      deleteBlocked: 'Kết nối đang được gán cho chức năng. Hãy đổi gán trước.',
    },
    assign: {
      title: 'Mô hình theo chức năng',
      help: 'Chọn kết nối cho từng chức năng. Thay đổi áp dụng từ lần gọi tiếp theo. Chức năng chưa gán sẽ dùng kết nối đang hoạt động đầu tiên.',
      feature: 'Chức năng', connection: 'Kết nối', updated: 'Cập nhật', none: '(chưa gán · kết nối đầu tiên)',
    },
    form: {
      addTitle: 'Thêm kết nối mô hình', editTitle: 'Sửa kết nối mô hình',
      connKey: 'Khóa kết nối', name: 'Tên', provider: 'Nhà cung cấp', apiBase: 'Địa chỉ API', modelName: 'Mô hình',
      loadModels: 'Tải danh sách mô hình', modelsLoaded: 'Đã tải {n} mô hình. Chọn trong ô nhập.', noModels: 'Danh sách mô hình trống.',
      apiKey: 'Khóa API', apiKeyKeep: 'Để trống để giữ khóa đã lưu', apiKeyEnv: 'Để trống để dùng khóa biến môi trường', clearKey: 'Xóa khóa đã lưu',
      workspaceId: 'ID workspace (tùy chọn)', workspaceHint: 'Chỉ nhập khi dùng khóa không gắn với workspace (sk-ant-usr…). Lấy ID workspace (wrkspc_…) trong Claude Console.',
      timeoutMs: 'Thời gian chờ (ms)', maxTokens: 'Token tối đa', temperature: 'temperature', effort: 'effort (độ sâu suy nghĩ)',
      sortOrder: 'Thứ tự', isActive: 'Sử dụng', description: 'Mô tả', default: 'mặc định',
      anthropicHint: 'Claude 5.x không nhận temperature mà điều chỉnh độ sâu suy nghĩ bằng effort. "low" nhanh nhất cho chat.',
      required: 'Khóa kết nối, tên và mô hình là bắt buộc.',
    },
    calls: {
      title: '100 lần gọi gần nhất', todayCalls: 'Gọi hôm nay', todayTokens: 'Token hôm nay', monthCalls: 'Gọi tháng này', monthTokens: 'Token tháng này',
      monthFailures: 'Thất bại tháng này', avgLatency: 'Độ trễ TB', byConnection: 'Tháng này theo kết nối',
      time: 'Thời gian', feature: 'Chức năng', connection: 'Kết nối', model: 'Mô hình', tenant: 'Cơ sở', inTokens: 'Token vào', outTokens: 'Token ra',
      latency: 'Độ trễ (ms)', result: 'Kết quả', failed: 'Thất bại', empty: 'Chưa có lịch sử gọi.',
    },
    msg: { saved: 'Đã lưu.', deleted: 'Đã xóa.', assigned: 'Đã đổi gán.', confirmDelete: "Xóa kết nối '{name}'?" },
  },
};

export default ai;
